import { Navigate, Outlet } from 'react-router';
import { IS_DEV_MODE } from '../../constants/env';

// These Routes works only on development environment
const DevRoutes = () => (IS_DEV_MODE ? <Outlet /> : <Navigate to='/' />);

export default DevRoutes;
